import React from 'react';

import UCThemeProvider from './UCThemeProvider';

import DatabaseHandler from '../database/DatabaseHandler';
import IShopInfo from "../unityView/interfaces/IShopInfo";
import CartHandler from '../cart/CartHandler';
import ParametersProcessor from '../parametersProcessor/ParametersProcessor';
import UnifiedLayout from './UnifiedLayout';
import CatalogHandler from '../catalog/CatalogHandler';
import PrestaGlobals from '../common/PrestaGlobals';
import AdminProvider from '../admin/AdminContext';
import AdminModeToggle from '../admin/AdminModeToggle';
import AdminPanel from '../admin/AdminPanel';
import AdminBadge from '../admin/AdminBadge';
import DescriptorEditorDialog from '../admin/DescriptorEditorDialog';
import AiDesignerProvider from '../aiDesigner/AiDesignerContext';
import AiDesignerPanel from '../aiDesigner/AiDesignerPanel';
import ShownDesignKeeper from '../common/ShownDesign';

interface IMainScreenProps {
    shopInfo: IShopInfo;
}

const MainScreen: React.FC<IMainScreenProps> = ({ shopInfo }) => {

    const [loadedReceived, setLoadedReceived] = React.useState(false);

    const handleUCOnLoadedReceived = () => {
        console.log("[App] UCOnLoadedReceived called");
        setLoadedReceived(true);
    }

    const handleUCOrderReceived = (result: any) => {
        console.log("[App] UCOrderReceived called, storing result...");
    }

    const handleUCViewChangedReceived = (key: string, value: string) => {
        console.log("[App] UCViewChangedReceived called with key:", key, "value:", value);
    }

    const layout = (sidePanel?: React.ReactNode) => <UnifiedLayout
        shopInfo={shopInfo}
        UCOnLoadedReceived={handleUCOnLoadedReceived}
        UCOrderReceived={handleUCOrderReceived}
        UCViewChangedReceived={handleUCViewChangedReceived}
        sidePanel={sidePanel}
    />;

    // The AI designer page (/ai-designer) is the same Designer with the AI designer panel in the
    // configurator's place; the catalog, the cart and the 3D view are shared.
    let content: React.ReactNode;
    if (PrestaGlobals.isAiDesigner) {
        content = (
            <AiDesignerProvider loaded={loadedReceived}>
                {layout(<AiDesignerPanel />)}
            </AiDesignerProvider>
        );
    } else if (PrestaGlobals.isAdmin) {
        content = (
            <AdminProvider>
                {layout()}
                <ShownDesignKeeper />
                <AdminModeToggle />
                <AdminPanel />
                <AdminBadge />
                <DescriptorEditorDialog />
            </AdminProvider>
        );
    } else {
        content = <>{layout()}<ShownDesignKeeper /></>;
    }

    return (
        <UCThemeProvider>
            <DatabaseHandler>
                <ParametersProcessor>
                    <CartHandler>
                        <CatalogHandler>
                            {content}
                        </CatalogHandler>
                    </CartHandler>
                </ParametersProcessor>
            </DatabaseHandler>
        </UCThemeProvider>
    );
};

export default MainScreen;